import Styled from 'styled-components';
import { respondTo } from '../../../respondTo';


export const BenefitsTextContainer = Styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 2.5rem 1.25rem 1.875rem;
    width: 100%;
    max-width: 1512px;

    ${respondTo.desktop`
        padding: 0 2.5rem 1.875rem;
    `}

    ${respondTo.desktop_xl`
        padding: 0 4.375rem;
    `}

`;

export const MainScreenContainer = Styled.div <{bgColor?: string}>`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
background-color: ${({bgColor}) => bgColor ? bgColor : ""};
width:100%;
${respondTo.desktop`
    padding:2.5rem 0;
`}
`;

export const ContainerMockup = Styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: auto;
    height: 100%;
    padding: 0 2.5rem 0.625rem;
    ${respondTo.desktop`
        padding: 0 1.25rem
        `};
`;


export const ContainerSelectorLarge = Styled.div`
    ${respondTo.tablet_portrait`
        display: flex !important;
          flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 1.875rem 0rem 0;
    `}

    ${respondTo.tablet_landscape`
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 1.875rem 10rem 0;
    `}
    ${respondTo.desktop`
        padding: 0 1.25rem 1.25rem;
        margin: 0 8.5rem 0;
    `}
`
export const BoxSelectorsLarge = Styled.div`
display: none;

${respondTo.tablet_portrait`
        display: flex;
        flex-direction: column;
        width: 10rem;
        min-height: 10.44rem;
        padding: 0 rem;
        align-items: center;
    `}
    ${respondTo.desktop`
        display: flex;
        flex-direction: column;
        width: 14.44rem;
        min-height: 10.44rem;
        padding: 0 1.25rem;
        align-items: center;
    `}

    ${respondTo.desktop_xl`
        width: 17rem;
    `}
`


export const MockupSelector = Styled.div<{ref?: any}>`
    display: flex;
    flex-direction: row;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    padding: 0.625rem 50% 2.5rem;
    scroll-snap-type: x mandatory;
    height: 100%;

    ::-webkit-scrollbar {
        display: none; // Safari and Chrome
    }
    -ms-overflow-style: none;  // IE and Edge
    scrollbar-width: none;  // Firefox


    ${respondTo.tablet_portrait`
        display: none;
    `}
    `

export const MockupContainer = Styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    `

export const MockupMobilBox = Styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 100%;
    padding: 0 0 0 1.25rem;

    ${respondTo.tablet_portrait`
        display: none;
    `}
`

export const ImgWrapper = Styled.div`
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 369px;
        height: 439px;

         ${respondTo.tablet_portrait`
         height: 439px;
            width: 728px;
    `}
     ${respondTo.tablet_landscape_s`
           height:582px;
           width: 960px;
    `}

    ${respondTo.desktop_xl`
            height:672.58px;
            width: 1114px;
`}
`


export const MockupDeskBox = Styled.div `
    display: none;
    ${respondTo.tablet_portrait`
            width: 100%;
            height: auto;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 1.25rem;

        
    `}
    ${respondTo.tablet_landscape_s`
            background-color: transparent;
            padding: 1.875rem 2.5rem 0;
            transition: opacity 1s ease-in-out;
            animation-duration: 1s;
            animation-iteration-count: 1;
            animation-timing-function: ease-in-out;
            animation-fill-mode: forwards;
            z-index: 1;
      
    `}

    ${respondTo.desktop_xl`
    padding: 1.875rem 4.375rem 0;

    `}
`

    export const SelectorContainer = Styled.div`
    display: block;
    `

    export const Selectors = Styled.div< {opacityElement? : boolean }>`
    align-items: flex-start;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    overflow-x: scroll;
    overflow-y: hidden;
    width: 100%;
    height: 100%;
    scroll-snap-type: x mandatory;
    gap : 1.25rem;
    padding: 2.5rem 1.25rem 0;

    position: relative;
    z-index: 0;

    ::-webkit-scrollbar {
        display: none; // Safari and Chrome
    }
    /* opacity: ${({opacityElement}:any) => opacityElement ? 1 : 0} ; */


    ${respondTo.tablet_portrait`
     padding: 2.5rem 1.25rem 0;
    `}

    ${respondTo.tablet_landscape_s`
        padding: 2.5rem 2.5rem 0;
    `}
    ${respondTo.desktop`
        padding: 2.5rem 2.5rem 0;
    `}

    ${respondTo.desktop_xl`
        padding: 2.5rem 4.375rem 0;
          scroll-snap-type: none;
    `}

    ${respondTo.desktop_xxl`
    justify-content: center;
        
        `}
    `





